import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
// import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import GlobalHeader from "./components/Global/Header/index.vue";
import GlobalFooter from "./components/Global/Footer/index.vue";
import GlobalAlert from "./components/Global/Alert/index.vue";
import GlobalLoading from "./components/Global/Loading/index.vue";
import GlobalCountdown from "./components/Global/Countdown/index.vue";
import GlobalCounddownClock from "./components/Global/Countdown/Clock.vue";
import GlobalSideBar from "./components/HomeSidebarRight.vue";
import store from "./store";
import VCalendar from "v-calendar";
import "v-calendar/dist/style.css";
import { getAvatar, getTitleDesc } from "./global_function/title";
import {
  playWordVoice,
  playSampleSentence,
  stopSound,
} from "./global_function/playWordVoice";
import { getCoverImg } from "./global_function/getCoverImg";
import { MsuAsidebar } from "./global_function/openAsidebar";
import dayjs from "dayjs";
import VueLazyLoad from "vue3-lazyload";
import i18n from "./locales/index.js";
import "@/assets/js/global/app.js";
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
import VueZoomer from "vue-zoomer";
import getDeviceType from "./global_function/getDeviceType";

const app = createApp(App);
app.use(VueZoomer);
app.use(VueViewer);

app.use(i18n);
// console.log(navigator.language);
if (
  localStorage.getItem("locale") !== null &&
  localStorage.getItem("locale") !== undefined
) {
  let locale = localStorage.getItem("locale");
  i18n.global.locale.value = locale;
}
app.provide("$screenType", function () {
  let width = document.documentElement.clientWidth;
  let height = document.documentElement.clientHeight;
  // console.log(width);
  // console.log(height);
  if (width > height) {
    // 橫
    return "landscape";
    console.log("landscape");
  } else {
    // 直
    return "vertical";
    console.log("vertical");
  }
});
app.provide("$getDevice", getDeviceType);
// app.provide("$getDevice", function () {
//   const ua = navigator.userAgent;
//   if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
//     return "tablet";
//   }
//   if (
//     /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
//       ua
//     )
//   ) {
//     return "mobile";
//   }
//   return "desktop";
// });

app.provide("$goPage", function (path, obj) {
  console.log("goPage = ", path);
  router.push({ path: path, query: obj });
});

app.provide("$MsuAsidebar", MsuAsidebar);
app.provide("$getAvatar", getAvatar);
app.provide("$getCoverImg", getCoverImg);
app.provide("$getTitleDesc", getTitleDesc);
app.provide("$playWordVoice", playWordVoice);
app.provide("$playSampleSentence", playSampleSentence);
app.provide("$stopSound", stopSound);
app.provide("$dayjs", dayjs);
app.use(VueLazyLoad, {});
app.use(VCalendar, {});
app.use(router);
app.use(store);
app.component("global-sidebar", GlobalSideBar);
app.component("global-header", GlobalHeader);
app.component("global-footer", GlobalFooter);
app.component("global-alert", GlobalAlert);
app.component("global-loading", GlobalLoading);
app.component("global-countdown", GlobalCountdown);
app.component("global-countdown-clock", GlobalCounddownClock);
router.isReady().then(() => app.mount("#app"));
// app.mount("#app");
